import axios from "axios";
import { supabase } from "../supabaseClient";

// CRM 2.0 step tracker (M1-F7). Server: GET /crm2/tracker/:allotmentPaymentId
// Returns { stage, day0At, deadlineAt, daysLeft, band, stages: { 1: { steps, done, total }, 2: {...} } }
async function getCrm2Tracker(allotmentPaymentId) {
  const url = `${process.env.REACT_APP_PAYMENT_LINK_URL}crm2/tracker/${allotmentPaymentId}`;
  const res = await axios.get(url, { headers: { Authorization: `Bearer ${supabase.auth.session()?.access_token}` } });
  return res.data.tracker;
}

// Is this booking on CRM 2.0? (AllotmentPayment.isCrm2, stamped at insert)
async function isCrm2Booking(allotmentPaymentId) {
  if (!allotmentPaymentId) return false;
  const { data, error } = await supabase.from("AllotmentPayment").select("isCrm2").eq("allotmentPaymentId", allotmentPaymentId).maybeSingle();
  if (error) throw error;
  return data?.isCrm2 === true;
}

export { getCrm2Tracker, isCrm2Booking };
